var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "标题" },
                model: {
                  value: _vm.paramsData.title,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "title", $$v)
                  },
                  expression: "paramsData.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "语言" },
                  model: {
                    value: _vm.paramsData.language,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "language", $$v)
                    },
                    expression: "paramsData.language"
                  }
                },
                _vm._l(_vm.language, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "公告分类"
                  },
                  model: {
                    value: _vm.paramsData.type_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "type_id", $$v)
                    },
                    expression: "paramsData.type_id"
                  }
                },
                _vm._l(_vm.announceTypeList, function(item) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(item.name) +
                          " ( " +
                          _vm._s(
                            _vm.language.filter(function(i) {
                              return i.value == item.language
                            })[0].label
                          ) +
                          " ) "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "作者" },
                model: {
                  value: _vm.paramsData.author,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "author", $$v)
                  },
                  expression: "paramsData.author"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "是否置顶" },
                  model: {
                    value: _vm.paramsData.top,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "top", $$v)
                    },
                    expression: "paramsData.top"
                  }
                },
                _vm._l(_vm.top, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "状态" },
                  model: {
                    value: _vm.paramsData.state,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "state", $$v)
                    },
                    expression: "paramsData.state"
                  }
                },
                _vm._l(_vm.state, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "公告类型"
                  },
                  model: {
                    value: _vm.paramsData.game_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "game_type", $$v)
                    },
                    expression: "paramsData.game_type"
                  }
                },
                _vm._l(_vm.AnnouncemenTypeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addannounce.init()
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _vm.delIds.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.del(_vm.delIds)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "announceListTable",
          attrs: { data: _vm.pagingList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60", type: "selection" }
          }),
          _c("el-table-column", { attrs: { prop: "title", label: "标题" } }),
          _c("el-table-column", { attrs: { prop: "author", label: "作者" } }),
          _c("el-table-column", {
            attrs: { prop: "cover", label: "公告分类", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(row.typeName) +
                          " ( " +
                          _vm._s(
                            _vm.language.filter(function(i) {
                              return i.value == row.language
                            })[0].label
                          ) +
                          " ) "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "game_type", label: "公告类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.game_type == "sys"
                      ? _c("div", [_vm._v(" 系统公告 ")])
                      : _vm._e(),
                    row.game_type == "game"
                      ? _c("div", [_vm._v(" 游戏公告 ")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "cover", label: "宣传图" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.cover && row.is_banner
                      ? _c("el-image", {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: {
                            src: _vm.$utils.imgTrow(row.cover),
                            fit: "cover",
                            "preview-src-list": [_vm.$utils.imgTrow(row.cover)]
                          }
                        })
                      : _c("div", [_vm._v("无")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "top", label: "是否置顶" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(" " + _vm._s(row.top ? "是" : "否") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "top", label: "是否为轮播图" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(" " + _vm._s(row.is_banner ? "是" : "否") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "language", label: "语言" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.language.filter(function(i) {
                              return i.value == row.language
                            })[0].label
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "content", label: "内容" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF" },
                        on: {
                          click: function($event) {
                            return _vm.viewOpen(row.content)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { style: { color: row.state == 1 ? "" : "red" } },
                      [_vm._v(" " + _vm._s(row.state == 1 ? "启用" : "禁用"))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "创建时间", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$times.timestampToTime(row.created_at)) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "定时发送", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(" " + _vm._s(row.is_timing ? "是" : "否") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "发送时间", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.is_timing == 1
                            ? _vm.$times.timestampToTime(row.timing)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "top", label: "是否开放评论" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(row.comment_type == 0 ? "不开放" : "开放") +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.addannounce.init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.pagingList.length
        ? _c("el-pagination", {
            staticClass: "x-c",
            attrs: {
              layout: "total, prev, pager, next,jumper",
              "current-page": _vm.paramsData.page,
              total: _vm.totalNum,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addannounce", {
        ref: "addannounce",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c(
        "el-drawer",
        {
          attrs: { title: "详情", visible: _vm.drawer },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "contentHtml", staticStyle: { padding: "0 20px" } },
            [_c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }